const kvWebAdminDomain = process.env.REACT_APP_ADMIN_URL;

export const urlRetailAdmin = {
  adminMerchant: `${kvWebAdminDomain}/retail/admin-merchant`,
  sso: `${kvWebAdminDomain}/retail/sso`,
};
export const urlFnBAdmin = {
  adminMerchant: `${kvWebAdminDomain}/fnb/admin-merchant`,
  sso: `${kvWebAdminDomain}/fnb/sso`,
};
